import React from 'react';
import { CgSpinner } from 'react-icons/cg';

export const LoadingSpinner = () => {

  return (
    <div className={`z-50 fixed top-0 left-0 right-0 bottom-0`}>
      <div className={"mx-auto h-full flex flex-col justify-center items-center"}>
        <div className={`h-32 w-32 flex flex-col justify-center items-center  p-3 rounded-xl`}>
          <CgSpinner className={"text-5xl animate-spin mb-3"} />
          <span className={"text-sm opacity-75"}>Loading...</span>
        </div>
      </div>
    </div>
  )
}
